import React, { Component } from 'react'

import Top from '../components/Top'

import TheDirect from '../components/TheDirect'

import AnnualReports from '../components/AnnualReports'

import ForumGuests from '../components/ForumGuests'

import MeetingAgenda from '../components/MeetingAgenda'

import Ad from '../components/Ad'

import Historical from '../components/Historical'

import Unit from '../components/Unit'

import Footer from '../components/Footer'

export default class Index extends Component {
    render() {
        return (
            <div>
                <Top />
                <TheDirect />
                <AnnualReports />
                <ForumGuests />
                <Ad />
                <MeetingAgenda />
                <Historical />
                <Unit />
                <Footer />
            </div>
        )
    }
}
